var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heatmap"},[(!_vm.isLoading)?_c('chart',{ref:"chart",attrs:{"options":_vm.chartOptions},on:{"click":_vm.onCellClick}}):_c('loading-spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }